<script setup>
import { useMapGetter } from 'dashboard/composables/store';

const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    :src="globalConfig.logoThumbnail || '/brand-assets/logo_thumbnail.svg'"
    :alt="globalConfig.installationName"
  />
</template>
